import { Box, Table, Text } from '@chakra-ui/react';
import type { ContactListMembership } from '../../types/contactDetail'

interface ListMembershipsSectionProps {
  memberships: ContactListMembership[]
}

export function ListMembershipsSection({ memberships }: ListMembershipsSectionProps) {
  if (memberships.length === 0) {
    return (
      <Box bg="surface" p={8} borderRadius="lg" shadow="md" textAlign="center">
        <Text color="gray.500">Not a member of any contact lists.</Text>
      </Box>
    )
  }

  return (
    <Box bg="surface" borderRadius="lg" shadow="md" overflow="hidden">
      <Box overflowX="auto">
      <Table.Root size="sm">
        <Table.Header bg="gray.50">
          <Table.Row>
            <Table.ColumnHeader>List Name</Table.ColumnHeader>
            <Table.ColumnHeader>Description</Table.ColumnHeader>
            <Table.ColumnHeader>Added</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {memberships.map((m) => (
            <Table.Row key={m.contactListId} _hover={{ bg: 'gray.50' }}>
              <Table.Cell fontWeight="medium">{m.listLabel}</Table.Cell>
              <Table.Cell fontSize="sm" color="gray.600">{m.listDescription || '-'}</Table.Cell>
              <Table.Cell fontSize="sm" color="gray.500">
                {new Date(m.addedAt).toLocaleDateString()}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
      </Box>
    </Box>
  );
}
